export const API_PATH_SUBSCRIPTIONS_CREATE = '/subscriptions/create'
export const API_PATH_SUBSCRIPTIONS_UPDATE = '/subscriptions/update'
export const API_PATH_SUBSCRIPTIONS_CANCEL = '/subscriptions/cancel'

export const API_PATH_CREATE_PAYMENT = '/payments/create'
export const API_PATH_UPDATE_PAYMENT = '/payments/update'

export const API_PATH_PROFILE_CREATE = '/profiles/create'
export const API_PATH_PROFILE_UPDATE = '/profiles/update'
export const API_PATH_SHIPPING_UPDATE = '/shippings/update'

export const API_PATH_TRANSACTIONS_CREATE = '/transactions/create'

export const API_PATH_ADMIN_SUBSCRIPTIONS_OVERVIEW =
  '/admin/subscriptions/overview'
export const API_PATH_ADMIN_CUSTOMER_WORKBENCH = '/admin/customers/workbench'
export const API_PATH_ADMIN_CUSTOMER_SEARCH = '/admin/customers/search'
export const API_PATH_ADMIN_CREATE_CUSTOMER_RENTAL =
  '/admin/workflows/create-customer-rental'
export const API_PATH_ADMIN_RENTAL_NOTE_SAVE =
  '/admin/rentals/details/note/save'
export const API_PATH_ADMIN_RENTAL_NOTE_DELETE =
  '/admin/rentals/details/note/delete'
export const API_PATH_ADMIN_RENTAL_VEHICLE_SAVE =
  '/admin/rentals/details/vehicle/save'
export const API_PATH_ADMIN_RENTAL_VEHICLE_DELETE =
  '/admin/rentals/details/vehicle/delete'
export const API_PATH_ADMIN_RENTAL_VEHICLE_ATTACHMENT_UPLOAD =
  '/admin/rentals/details/vehicle/attachment/upload'
export const API_PATH_ADMIN_RENTAL_VEHICLE_ATTACHMENT_DELETE =
  '/admin/rentals/details/vehicle/attachment/delete'
export const API_PATH_ADMIN_RENTAL_VEHICLE_ATTACHMENT_DOWNLOAD =
  '/admin/rentals/details/vehicle/attachment'
export const API_PATH_PORTAL_BOOTSTRAP = '/portal/bootstrap'
export const API_PATH_PORTAL_CLAIM_ACCESS = '/portal/claim-access'

export const API_PATH_REPORT_AUDIT = '/report/audit'
export const API_PATH_REPORT_AUDIT_SEND = '/report/audit/send'
export const API_PATH_REPORT_BATCH_SETTLEMENT = '/report/batch-settlement'
